import { Term } from 'services/ContentfulService/models/term'
import { getAbstract } from 'components/vendor/Contentful/richText/utils'
import { Text, View } from 'reshaped/bundle'
import { Link } from 'ui/reshaped/Link'

interface Props {
	term: Term
}

export const GlossaryTerm = ({ term }: Props) => {
	const href = { pathname: term.relativePath }
	return (
		<View gap={4} maxWidth={{ l: '413px' }}>
			<Link href={href.pathname} variant="plain" textVariant="title-6" color="primary">
				{term.name}
			</Link>
			<Text variant="body-2" color="neutral">
				{getAbstract(term.definition)}
			</Text>
		</View>
	)
}
